module.exports = "../images/avatar-awaiting.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/avatar-awaiting.png
// module id = 910
// module chunks = 1